
if (process.env.NODE_ENV == 'production') {
    var base = {
        url: 'https://www.qifufu.com.cn/tenant',
        systemUrl: 'https://www.qifufu.com.cn/tenant',
        cmsUrl: "https://www.ronghuinanhai.com/portal", // 官网后台接口
        wxUrl: 'https://wxpa.qifufu.com.cn', //微信登录接口
    };
} else if (process.env.NODE_ENV == 'development') {
    var base = {
        url: 'http://192.168.0.151:18390',
        systemUrl: 'http://192.168.0.151:18390',
        // url: '/api',
        // systemUrl: '/api',
        cmsUrl: "http://118.195.226.181:19010", // 官网后台接口
        wxUrl: 'http://118.195.185.157:9070', //微信登录接口
    };
} else if (process.env.NODE_ENV == 'test') {
    var base = {
        url: 'https://test-www.qifufu.com.cn/tenant',
        systemUrl: 'https://test-www.qifufu.com.cn/tenant',
        cmsUrl: "https://test-www.ronghuinanhai.com/portal", // 官网后台接口
        wxUrl: 'https://test-wxpa.qifufu.com.cn', //微信登录接口
    };
}
export default base;
